/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiV0NodeitemCreateFolderNodeItemPost } from '../fn/node-item/api-v-0-nodeitem-create-folder-node-item-post';
import { ApiV0NodeitemCreateFolderNodeItemPost$Params } from '../fn/node-item/api-v-0-nodeitem-create-folder-node-item-post';
import { apiV0NodeitemDeleteDelete } from '../fn/node-item/api-v-0-nodeitem-delete-delete';
import { ApiV0NodeitemDeleteDelete$Params } from '../fn/node-item/api-v-0-nodeitem-delete-delete';
import { apiV0NodeitemGetbycompanyidGet$Json } from '../fn/node-item/api-v-0-nodeitem-getbycompanyid-get-json';
import { ApiV0NodeitemGetbycompanyidGet$Json$Params } from '../fn/node-item/api-v-0-nodeitem-getbycompanyid-get-json';
import { apiV0NodeitemGetbycompanyidGet$Plain } from '../fn/node-item/api-v-0-nodeitem-getbycompanyid-get-plain';
import { ApiV0NodeitemGetbycompanyidGet$Plain$Params } from '../fn/node-item/api-v-0-nodeitem-getbycompanyid-get-plain';
import { apiV0NodeitemGetNodeItemByIdGet$Json } from '../fn/node-item/api-v-0-nodeitem-get-node-item-by-id-get-json';
import { ApiV0NodeitemGetNodeItemByIdGet$Json$Params } from '../fn/node-item/api-v-0-nodeitem-get-node-item-by-id-get-json';
import { apiV0NodeitemGetNodeItemByIdGet$Plain } from '../fn/node-item/api-v-0-nodeitem-get-node-item-by-id-get-plain';
import { ApiV0NodeitemGetNodeItemByIdGet$Plain$Params } from '../fn/node-item/api-v-0-nodeitem-get-node-item-by-id-get-plain';
import { apiV0NodeitemMoveNodeItemsPost } from '../fn/node-item/api-v-0-nodeitem-move-node-items-post';
import { ApiV0NodeitemMoveNodeItemsPost$Params } from '../fn/node-item/api-v-0-nodeitem-move-node-items-post';
import { apiV0NodeitemRenameNodeItemPost } from '../fn/node-item/api-v-0-nodeitem-rename-node-item-post';
import { ApiV0NodeitemRenameNodeItemPost$Params } from '../fn/node-item/api-v-0-nodeitem-rename-node-item-post';
import { NodeItem } from '../models/node-item';

@Injectable({ providedIn: 'root' })
export class NodeItemService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV0NodeitemGetNodeItemByIdGet()` */
  static readonly ApiV0NodeitemGetNodeItemByIdGetPath = '/api/v0/nodeitem/getNodeItemById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0NodeitemGetNodeItemByIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0NodeitemGetNodeItemByIdGet$Plain$Response(params?: ApiV0NodeitemGetNodeItemByIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<NodeItem>> {
    const obs = apiV0NodeitemGetNodeItemByIdGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0NodeitemGetNodeItemByIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0NodeitemGetNodeItemByIdGet$Plain(params?: ApiV0NodeitemGetNodeItemByIdGet$Plain$Params, context?: HttpContext): Observable<NodeItem> {
    const resp = this.apiV0NodeitemGetNodeItemByIdGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<NodeItem>): NodeItem => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0NodeitemGetNodeItemByIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0NodeitemGetNodeItemByIdGet$Json$Response(params?: ApiV0NodeitemGetNodeItemByIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<NodeItem>> {
    const obs = apiV0NodeitemGetNodeItemByIdGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0NodeitemGetNodeItemByIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0NodeitemGetNodeItemByIdGet$Json(params?: ApiV0NodeitemGetNodeItemByIdGet$Json$Params, context?: HttpContext): Observable<NodeItem> {
    const resp = this.apiV0NodeitemGetNodeItemByIdGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<NodeItem>): NodeItem => r.body)
    );
  }

  /** Path part for operation `apiV0NodeitemGetbycompanyidGet()` */
  static readonly ApiV0NodeitemGetbycompanyidGetPath = '/api/v0/nodeitem/getbycompanyid';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0NodeitemGetbycompanyidGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0NodeitemGetbycompanyidGet$Plain$Response(params?: ApiV0NodeitemGetbycompanyidGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NodeItem>>> {
    const obs = apiV0NodeitemGetbycompanyidGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0NodeitemGetbycompanyidGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0NodeitemGetbycompanyidGet$Plain(params?: ApiV0NodeitemGetbycompanyidGet$Plain$Params, context?: HttpContext): Observable<Array<NodeItem>> {
    const resp = this.apiV0NodeitemGetbycompanyidGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<NodeItem>>): Array<NodeItem> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0NodeitemGetbycompanyidGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0NodeitemGetbycompanyidGet$Json$Response(params?: ApiV0NodeitemGetbycompanyidGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NodeItem>>> {
    const obs = apiV0NodeitemGetbycompanyidGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0NodeitemGetbycompanyidGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0NodeitemGetbycompanyidGet$Json(params?: ApiV0NodeitemGetbycompanyidGet$Json$Params, context?: HttpContext): Observable<Array<NodeItem>> {
    const resp = this.apiV0NodeitemGetbycompanyidGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<NodeItem>>): Array<NodeItem> => r.body)
    );
  }

  /** Path part for operation `apiV0NodeitemCreateFolderNodeItemPost()` */
  static readonly ApiV0NodeitemCreateFolderNodeItemPostPath = '/api/v0/nodeitem/createFolderNodeItem';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0NodeitemCreateFolderNodeItemPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0NodeitemCreateFolderNodeItemPost$Response(params?: ApiV0NodeitemCreateFolderNodeItemPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0NodeitemCreateFolderNodeItemPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0NodeitemCreateFolderNodeItemPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0NodeitemCreateFolderNodeItemPost(params?: ApiV0NodeitemCreateFolderNodeItemPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0NodeitemCreateFolderNodeItemPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0NodeitemRenameNodeItemPost()` */
  static readonly ApiV0NodeitemRenameNodeItemPostPath = '/api/v0/nodeitem/renameNodeItem';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0NodeitemRenameNodeItemPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0NodeitemRenameNodeItemPost$Response(params?: ApiV0NodeitemRenameNodeItemPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0NodeitemRenameNodeItemPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0NodeitemRenameNodeItemPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0NodeitemRenameNodeItemPost(params?: ApiV0NodeitemRenameNodeItemPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0NodeitemRenameNodeItemPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0NodeitemMoveNodeItemsPost()` */
  static readonly ApiV0NodeitemMoveNodeItemsPostPath = '/api/v0/nodeitem/moveNodeItems';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0NodeitemMoveNodeItemsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0NodeitemMoveNodeItemsPost$Response(params?: ApiV0NodeitemMoveNodeItemsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0NodeitemMoveNodeItemsPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0NodeitemMoveNodeItemsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0NodeitemMoveNodeItemsPost(params?: ApiV0NodeitemMoveNodeItemsPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0NodeitemMoveNodeItemsPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0NodeitemDeleteDelete()` */
  static readonly ApiV0NodeitemDeleteDeletePath = '/api/v0/nodeitem/delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0NodeitemDeleteDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0NodeitemDeleteDelete$Response(params?: ApiV0NodeitemDeleteDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0NodeitemDeleteDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0NodeitemDeleteDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0NodeitemDeleteDelete(params?: ApiV0NodeitemDeleteDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0NodeitemDeleteDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
